import { render } from "./NotificationPage.vue?vue&type=template&id=28d6b3cb&ts=true"
import script from "./NotificationPage.vue?vue&type=script&lang=ts"
export * from "./NotificationPage.vue?vue&type=script&lang=ts"

import "./NotificationPage.vue?vue&type=style&index=0&id=28d6b3cb&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__